import { ErrorResponseHandler } from 'api/ErrorResponseHandler';
import axios, { AxiosError } from 'axios';
import { ErrorResponse, SuccessResponse } from 'types/api';
import { PayloadProps } from 'types/api/user/getLatestVersion';

/**
 * Upstream asked GitHub for its own newest release on every app load. This is a
 * fork on its own release cadence, so that answer was both an outbound request
 * to the vendor from every customer's browser and a prompt telling them to
 * upgrade to a version of a product they are not running.
 *
 * Reporting the running version as the newest keeps the version banner quiet
 * and the comparison in `checkVersionState` honest, without unpicking the
 * redux flow that consumes it.
 */
const getLatestVersion = async (): Promise<
	SuccessResponse<PayloadProps> | ErrorResponse
> => {
	try {
		const response = await axios.get<{ version: string }>('/api/v1/version');

		return {
			statusCode: 200,
			error: null,
			message: 'success',
			// The consumer compares this against the running version's core
			// (everything before the first '-'), so match that split or a build
			// tagged `v1.2.3-abc123` reports itself perpetually out of date.
			payload: {
				tag_name: (response.data?.version ?? '').split('-')[0],
			} as PayloadProps,
		};
	} catch (error) {
		return ErrorResponseHandler(error as AxiosError);
	}
};

export default getLatestVersion;
